import { setClientEnv as setClientEnvRepo } from '../repositories/clientEnvRepository'

export function setClientEnv(props?: Record<string, unknown>) {
  setClientEnvRepo(props)
}
